<template>
  <div>
    <div v-for="(drug, index) in drugs" :key="index" class="flex mb-1">
      <div class="selectDrugBlock">
        <DrugSearchNew
          ref="selectedDrug"
          :searchOptions="{prices: true}"
          :onSelect="selectDrug"
        />
      </div>
      <!--      <drugSearch-->
      <!--        class="selectDrugBlock"-->
      <!--        ref="selectedDrug"-->
      <!--        :drugSelected="drug"-->
      <!--        :alreadySelectedCheck="alreadySelectedCheck"-->
      <!--        :enableQty="true"-->
      <!--        :getPrice="{siteId: 1}"-->
      <!--        :updateDrug="updateDrugs"-->
      <!--      />-->
      <div>
        <input @change="updateDrugs" type="number" v-model="drug.qty" class="form-control">
      </div>
      <div>
        <input disabled type="text" v-model="drug.price" class="form-control">
      </div>
    </div>
    <div>
      <button @click="addNewDrug" class="btn-xs btn btn-info m-t-10">Добавить препарат</button>
    </div>
  </div>
</template>

<script>

import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";

export default {
  components: {
    DrugSearchNew,
  },
  props: ['drugsUpdated'],
  data() {
    return {
      siteId: 1,
      drugs: [{}],
    }
  },
  methods: {
    alreadySelectedCheck(drug) {
      const drugs = this.collectDrugs();
      let check = drugs.filter((d) => d.id == drug.id);
      return check.length >= 2;
    },
    addNewDrug() {
      let hasEmpty = this.collectDrugs(false);
      if (!hasEmpty) {
        this.drugs.push({});
      }
    },
    getPriceByQty(drug) {
      if (drug.prices) {
        const prices = _.orderBy(drug.prices, 'qty', 'desc');
        let price = 0;
        prices.forEach((p) => {
          if (p.site_id == this.siteId && drug.qty >= p.qty && price === 0) price = p.price * drug.pack_set;
        })
        return price;
      }
      return drug.price;
    },
    collectDrugs(clear = true) {
      let drugs = [];
      let hasEmpty = false;
      this.$refs.selectedDrug.forEach((sd) => {
        if ((!sd.drug || !sd.drug.id) && !clear) {
          hasEmpty = true;
          return;
        }
        if (clear && sd.drug && sd.drug.id) {
          drugs.push(sd.drug);
        }
      })
      return clear ? drugs : hasEmpty;
    },
    selectDrug(d) {
      this.updateDrugs();
    },
    updateDrugs() {
      let drugs = this.collectDrugs();
      drugs.forEach((d) => {
        if (!d.qty) d.qty = 1;
        d.price = this.getPriceByQty(d);
      })
      this.drugs = [...drugs];
      if (this.drugsUpdated) {
        this.drugsUpdated();
      }
      this.addNewDrug();
    },
  }
}

</script>

<style scoped>
.selectDrugBlock {
  width: calc(100% - 150px);
}

.price_field {
  width: 90px;
  height: 34px;
}
</style>
